export class FeedstockBreakdownDataItem {
  'COMMON.FEEDSTOCK';
  'RESULTS.GENERAL.AMOUNT';
  'RESULTS.DATA.UNIT';
  'RESULTS.GENERAL.SHARE';

  get feedstock() {
    return this['COMMON.FEEDSTOCK'];
  }
  set feedstock(value: string) {
    this['COMMON.FEEDSTOCK'] = value;
  }
  get amount() {
    return this['RESULTS.GENERAL.AMOUNT'];
  }
  set amount(value: string) {
    this['RESULTS.GENERAL.AMOUNT'] = value;
  }
  get unit() {
    return this['RESULTS.DATA.UNIT'];
  }
  set unit(value: string) {
    this['RESULTS.DATA.UNIT'] = value;
  }
  get share() {
    return this['RESULTS.GENERAL.SHARE'];
  }
  set share(value: string) {
    this['RESULTS.GENERAL.SHARE'] = value;
  }

  public constructor(feedstock: string, amount: string, unit: string, share: string) {
    this['COMMON.FEEDSTOCK'] = feedstock;
    this['RESULTS.GENERAL.AMOUNT'] = amount;
    this['RESULTS.DATA.UNIT'] = unit;
    this['RESULTS.GENERAL.SHARE'] = share;
  }

  deepCopy() {
    return new FeedstockBreakdownDataItem(this.feedstock, this.amount, this.unit, this.share);
  }
}
